import { AnalyticTypes } from '../../../admin/analytics/types/AnalyticsTypes';
import {
  AnalyticPercentageDTO,
  AnalyticPercentageResponseDTO,
  AnalyticsPercentageValueDTO,
} from '../dtos/AnalyticPercentage.dto';
import {
  AnalyticPercentageDataModel,
  AnalyticPercentageModel,
} from '../models/AnalyticPercentage.model';

export class AnalyticPercentageUtil {
  public static dataToViewModel(
    dto: AnalyticsPercentageValueDTO,
  ): AnalyticPercentageDataModel {
    return {
      name: dto.label,
      value: dto.value,
    };
  }

  public static mapToViewModel(
    dto: AnalyticPercentageResponseDTO,
  ): AnalyticPercentageModel {
    const content: AnalyticPercentageDTO | undefined = dto.data.find(
      (item) => item.type === AnalyticTypes.CONTENT,
    );
    const user: AnalyticPercentageDTO | undefined = dto.data.find(
      (item) => item.type === AnalyticTypes.USER,
    );
    const notifications: AnalyticPercentageDTO | undefined = dto.data.find(
      (item) => item.type === AnalyticTypes.NOTIFICATION,
    );

    return {
      CONTENT: content
        ? content.data
            .map((item) => AnalyticPercentageUtil.dataToViewModel(item))
            .sort((a, b) => a.value - b.value)
        : [],
      NOTIFICATION: notifications
        ? notifications.data
            .map((item) => AnalyticPercentageUtil.dataToViewModel(item))
            .sort((a, b) => a.value - b.value)
        : [],
      USER: user
        ? user.data
            .map((item) => AnalyticPercentageUtil.dataToViewModel(item))
            .sort((a, b) => a.value - b.value)
        : [],
    };
  }
}
